{
  "version": 1,
  "asset_id": "0fc0a571-146e-4602-bbbe-1ab5b96b1e9e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0fc0a571-146e-4602-bbbe-1ab5b96b1e9e/sleeve-fitzer-2-440.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0fc0a571-146e-4602-bbbe-1ab5b96b1e9e/sleeve-fitzer-2-440.webp",
  "original_filename": "sleeve-fitzer-2-440.webp",
  "size": 9636,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:30Z"
}
